export default function Advantage() {
  const advantages = [
    {
      icon: 'ri-gamepad-line',
      title: 'Authentic Voice',
      description: 'I\'m not a professional critic trying to sound like a kid. I AM a kid. You get real, unfiltered feedback on what actually makes games fun for my age group.',
    },
    {
      icon: 'ri-focus-3-line',
      title: 'Target Demo Expert',
      description: 'Want to know if 11-13 year olds will actually play your game? I\'ll tell you exactly what works, what doesn\'t, and what my friends would think.',
    },
    {
      icon: 'ri-mac-line',
      title: 'Mac Native',
      description: 'I play exclusively on Mac, so I know exactly how games perform on this platform. I\'ll catch Mac-specific issues that other testers might miss.',
    },
  ];

  return (
    <section id="why-me" className="py-16 md:py-32 px-4 md:px-8 bg-[#242428]">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12 md:mb-20">
          <div className="inline-block px-4 md:px-6 py-2 bg-[#00f0ff] text-[#0d0d0f] font-bold text-xs md:text-sm uppercase tracking-wider rounded-full mb-4 md:mb-6">
            WHY ME
          </div>
          <h2 className="text-3xl md:text-6xl font-bold text-white px-4">The Real Gamer Advantage</h2>
        </div>

        <div className="grid md:grid-cols-3 gap-6 md:gap-10">
          {advantages.map((item, index) => (
            <div
              key={index}
              className="bg-[#1a1a1d] rounded-2xl md:rounded-3xl p-6 md:p-12 hover:shadow-[0_0_30px_rgba(0,240,255,0.3)] transition-all duration-300 hover:-translate-y-2 cursor-pointer"
            >
              <div className="w-14 h-14 md:w-20 md:h-20 bg-[#39ff14] rounded-full flex items-center justify-center mb-4 md:mb-8">
                <i className={`${item.icon} text-2xl md:text-4xl text-white`}></i>
              </div>
              <h3 className="text-xl md:text-3xl font-bold text-white mb-3 md:mb-5">{item.title}</h3>
              <p className="text-[#b8b8b8] text-sm md:text-lg leading-relaxed">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
